import { BroadcastChannel } from 'broadcast-channel';
import { getPathFromState } from './utils';

export const VKHandler = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get('code');
  const state = searchParams.get('state') || '';

  const pathFromState = getPathFromState(state);

  /**
   * Обработчик для VK авторизации с редиректом (когда в state есть путь)
   */
  const handleRedirectFlow = () => {
    const targetPath = pathFromState || '/';
    const newUrl = new URL(`${window.location.origin}${targetPath}`);

    if (code) {
      newUrl.searchParams.set('code', code);
      if (state) {
        newUrl.searchParams.set('state', state);
      }
    } else {
      newUrl.searchParams.set('error', 'auth_failed');
    }

    window.location.replace(newUrl.toString());
  };

  /**
   * Обработчик для VK авторизации в обычном браузере (попап)
   */
  const handleBrowserFlow = () => {
    const chanel = new BroadcastChannel('auth-vk-code');

    if (code) {
      chanel.postMessage({
        code,
        success: true,
      });
    } else {
      const error = {};
      searchParams.forEach((value, key) => {
        error[key] = value;
      });
      chanel.postMessage({
        success: false,
        error,
      });
    }
    setTimeout(() => {
      window.close();
    }, 250);
  };

  if (pathFromState) {
    handleRedirectFlow();
  } else {
    handleBrowserFlow();
  }
};
